﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import VeilederOblDto from '../Models/VeilederOblDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { valgReducer } from './Valg/Reducers';

const rootReducer = combineReducers<VeilederOblAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    epiContext: (
        state: EpiContext<VeilederOblDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederOblDto>,
    ): EpiContext<VeilederOblDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
});

export type VeilederOblAppState = EpiAppStateMedSteg<VeilederOblDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
};

export default function configureStore(): Store<VeilederOblAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
